<template>
  <div>
    <v-text-field
      v-if="useTextField"
      :value="textFieldValue"
      :label="label"
      :dense="dense"
      :disabled="disabled"
      :clearable="clearable"
      :hide-details="hideDetails"
      :error-messages="textFieldErrorMessages"
      outlined
      autocomplete="off"
      inputmode="numeric"
      placeholder="t.ex. 1430"
      @input="onTextFieldInput"
      @blur="commitTextFieldValue"
      @focus="$event.target.select()"
      @keydown.enter="$event.target.blur()"
    ></v-text-field>
    <v-select
      v-else
      v-model="time"
      :items="timeOptions"
      item-text="text"
      item-value="val"
      :label="label"
      :dense="dense"
      :disabled="disabled"
      :clearable="clearable"
      :hide-details="hideDetails"
      outlined
    ></v-select>
  </div>
</template>

<script>

export default {
  name: 'TimePicker',
  props: {
    value: String,
    label: String,
    allowedMinutes: {
      type: Array,
      default: () => [0, 15, 30, 45]
    },
    firstHour: {
      type: Number,
      default: 0
    },
    lastHour: {
      type: Number,
      default: 23
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: [Boolean, String],
      default: true
    },
    useTextField: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    textFieldValue: '',
    textFieldError: ''
  }),
  computed: {
    time: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    },
    timeOptions: function () {
      const times = []
      for (let hour = this.firstHour; hour <= this.lastHour; hour++) {
        for (const minute of this.allowedMinutes) {
          const hourStr = hour.toString().padStart(2, '0')
          const minuteStr = minute.toString().padStart(2, '0')
          times.push(`${hourStr}:${minuteStr}`)
        }
      }
      return times
    },
    textFieldErrorMessages: function () {
      return this.textFieldError ? [this.textFieldError] : []
    }
  },
  methods: {
    parseTextFieldTime: function (value) {
      const time = (value || '').trim()
      if (time === '') {
        return ''
      }

      const withColon = time.match(/^(\d{1,2}):(\d{2})$/)
      if (withColon) {
        const hour = parseInt(withColon[1], 10)
        const minute = parseInt(withColon[2], 10)
        if (hour > 23 || minute > 59) {
          return null
        }
        return `${hour.toString().padStart(2, '0')}:${withColon[2]}`
      }

      const fourDigits = time.match(/^(\d{4})$/)
      if (fourDigits) {
        const hour = parseInt(time.slice(0, 2), 10)
        const minute = parseInt(time.slice(2, 4), 10)
        if (hour > 23 || minute > 59) {
          return null
        }
        return `${time.slice(0, 2)}:${time.slice(2, 4)}`
      }

      return null
    },
    onTextFieldInput: function (value) {
      this.textFieldValue = value
      this.textFieldError = ''
    },
    commitTextFieldValue: function () {
      const parsedTime = this.parseTextFieldTime(this.textFieldValue)
      if (parsedTime === null) {
        this.textFieldError = 'Ogiltig tid. Ange som TTMM'
        this.$emit('input', '')
        return
      }

      this.textFieldError = ''
      this.textFieldValue = parsedTime
      this.$emit('input', parsedTime)
    },
    syncTextFieldValue: function () {
      this.textFieldValue = this.value || ''
      this.textFieldError = ''
    }
  },
  watch: {
    value: function () {
      this.syncTextFieldValue()
    },
    useTextField: function () {
      this.syncTextFieldValue()
    }
  },
  mounted: function () {
    this.syncTextFieldValue()
  }
}
</script>
